<template>
	<div class="dialogBox" >
		<el-dialog :title="title" :visible.sync="innerVisible" width="610px" center @closed="innerVisible = false">
			<el-table :data="table_data" border max-height="920px" class="table" :cell-style="{ padding: '0' }">
				<el-table-column align="center" prop="liusui" :label="$t('FlowAlgorithm')" width="140">
					<template slot-scope="scope">
						<span>{{ liusuiConfig[scope.row.liusui] }}</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="vip"  :label="$t('VIPFlow')" width="140">
					<template slot-scope="scope">
						<span>{{ vipGame[scope.row.vip] }}</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="bili" :label="$t('CommissionRebateRatio')" width="140"></el-table-column>
				<el-table-column  :label="$t('Actions')">
					<template slot-scope="scope">
						<el-button type="text" icon="el-icon-edit" @click="handleModifyItem(scope.$index)">{{$t('Edit')}}</el-button>
					</template>
				</el-table-column>
			</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="handleCommit()">{{$t('Save')}}</el-button>
			</span>
		</el-dialog>
		<el-dialog class="inputPop" :title="title" :visible.sync="adddialog" width="380px" center>
			<el-form :inline="true">
				<el-form-item :label="$t('FlowAlgorithm')">
					<el-radio-group v-model="liusui">
					    <el-radio :label="1">{{liusuiConfig['1']}}</el-radio>
					    <el-radio :label="2">{{liusuiConfig['2']}}</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<el-form :inline="true">
				<el-form-item label="参加vip流水:">
					<el-radio-group v-model="vip">
					    <el-radio :label="1">{{vipGame['1']}}</el-radio>
					    <el-radio :label="2">{{vipGame['2']}}</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<el-form :inline="true">
				<el-form-item :label="$t('CommissionRebateRatio')+':'">
					<el-input type="number" v-model="bili" :placeholder="$t('PleaseEnter')" ></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="handleCommitItem()">{{$t('Confirm')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { app } from '@/api/app.js'
import base from '@/api/base.js'
export default {
	extends: base,
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		dialogData: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			title: '设置佣金配置',
			table_data: [],
			adddialog: false,
			liusuiConfig: {
				"1": '单边',
				"2": '输赢绝对值',
			},
			vipGame: {
				"1": '参加',
				"2": '不参加',
			},
			liusui: null,
			bili: null,
			vip: null,
		}
	},
	computed: {
		innerVisible: {
			get: function () {
				return this.show
			},
			set: function (val) {
				this.table_data = []
				this.liusui = null
				this.bili = null
				this.vip = null
				this.$emit('update:show', val)
			},
		},
	},
	watch: {
		dialogData(newData, oldData) {
			this.initData();
		}
	},
	created() {
		this.app = app
	},
	methods: {
		initData() {
			if(this.dialogData.data.ConfigValue){
				var data = JSON.parse(this.dialogData.data.ConfigValue)
				if(!data.vip) {
					data.vip = 2
				}
				if(!data.liusui) {
					data.liusui = 2
				}
				if(!data.bili) {
					data.bili = 0.02
				}
				this.table_data = [data];
			}else {
				this.liusui = 1
				this.vip = 2,
				this.table_data = [
					{
						liusui: 2,
						bili: 0.02,
						vip: 2,
					}
				];
			}
			
		},
		handleModifyItem(index) {
			this.adddialog = true
			this.liusui = this.table_data[0].liusui
			this.bili = this.table_data[0].bili
			this.vip = this.table_data[0].vip
		},
		handleCommit() {
			this.dialogData.data.ConfigValue = JSON.stringify(this.table_data[0])
			app.getGoogleCode((GoogleCode) => {
				this.dialogData.data.GoogleCode = GoogleCode
				app.post('/admin/config/modify', this.dialogData.data, (result) => {
					this.innerVisible = false
					this.$message.success('提交成功')
					this.$emit('updataInfo')
				})
				
			})
		},
		handleCommitItem() {
			this.adddialog = false
			this.table_data[0].liusui = Number(this.liusui)
			this.table_data[0].bili = Number(this.bili)
			this.table_data[0].vip = Number(this.vip)
		},
	},
}
</script>

<style scoped>
.inputPop ::v-deep .el-form-item__label {
	width: 100px;
	text-align: right;
}
</style>
